var _excluded = ["spacingSpace", "color", "colorEmphasis", "customColor", "shadow", "hasInvertedShadow", "borderRadiusSize", "hasBorder", "borderEmphasis", "hasCenteredChildren", "borderWidth", "children", "display", "id", "backgroundImage", "backgroundBlurUnit", "role"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import { defaultProps } from "./SurfaceOrg.props";
import { StyledSurfaceOrg } from "./SurfaceOrg.styled";
var SurfaceOrg = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var spacingSpace = _ref.spacingSpace,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? defaultProps.color : _ref$color,
    colorEmphasis = _ref.colorEmphasis,
    customColor = _ref.customColor,
    _ref$shadow = _ref.shadow,
    shadow = _ref$shadow === void 0 ? defaultProps.shadow : _ref$shadow,
    hasInvertedShadow = _ref.hasInvertedShadow,
    _ref$borderRadiusSize = _ref.borderRadiusSize,
    borderRadiusSize = _ref$borderRadiusSize === void 0 ? defaultProps.borderRadiusSize : _ref$borderRadiusSize,
    hasBorder = _ref.hasBorder,
    borderEmphasis = _ref.borderEmphasis,
    hasCenteredChildren = _ref.hasCenteredChildren,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? defaultProps.borderWidth : _ref$borderWidth,
    children = _ref.children,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? defaultProps.display : _ref$display,
    id = _ref.id,
    backgroundImage = _ref.backgroundImage,
    backgroundBlurUnit = _ref.backgroundBlurUnit,
    role = _ref.role,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledSurfaceOrg, _extends({
    $spacingSpace: spacingSpace,
    $color: color,
    $colorEmphasis: colorEmphasis,
    $customColor: customColor,
    $shadow: shadow,
    $hasInvertedShadow: !!hasInvertedShadow,
    $borderRadiusSize: borderRadiusSize,
    $hasBorder: !!hasBorder,
    $borderEmphasis: borderEmphasis,
    $hasCenteredChildren: !!hasCenteredChildren,
    $borderWidth: borderWidth,
    $display: display,
    $backgroundImage: backgroundImage,
    $backgroundBlurUnit: backgroundBlurUnit,
    id: id,
    role: role
  }, restProps, {
    ref: ref
  }), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: color
  }, children));
});
export default SurfaceOrg;